import { render, staticRenderFns } from "./TermField.vue?vue&type=template&id=0fb89e3d"
import script from "./TermField.vue?vue&type=script&lang=js"
export * from "./TermField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports